import { render, staticRenderFns } from "./tutorialPopUp.vue?vue&type=template&id=fb2e99ea"
import script from "./tutorialPopUp.vue?vue&type=script&lang=js"
export * from "./tutorialPopUp.vue?vue&type=script&lang=js"
import style0 from "./tutorialPopUp.vue?vue&type=style&index=0&id=fb2e99ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports